import React, { useState, useEffect, useCallback } from 'react';
import { useMap } from 'react-leaflet';
import { useSelector, useDispatch } from 'react-redux';
import L from 'leaflet';
import { renderToString } from 'react-dom/server'

import {
    visibleMarkersMapSelector, markerDetailViewSelector,
} from '../../../features/places/placesSlice';
import { setCenter, setZoom, mapControlSelector } from '../../../features/map/mapSlice';

import { mdiMapMarkerRadius } from '@mdi/js';
import Icon from '@mdi/react';

const iconToolsColor = "Ivory";


const OsmPlaceMarker = ({ markerId }) => {
    const map = useMap();
    const dispatch = useDispatch();
    const markerData = useSelector(state => state.places.markers[`${markerId}`]);
    const visibleMarkersMap = useSelector(visibleMarkersMapSelector);
    const markerDetailView = useSelector(markerDetailViewSelector);
    const mapControl = useSelector(mapControlSelector);
    //const opacity = markerEditData.marker_id === markerDetailView ? 0.5 : 1;
    let lat = 23.5251;
    let lng = 77.8081;

    if (markerData) {
        lat = parseFloat(markerData.marker_coords.lat);
        lng = parseFloat(markerData.marker_coords.lng);
    }

    const [showLabel, setshowLabel] = useState(false);

    useEffect(() => {
        if (visibleMarkersMap.length < 6) {
            setshowLabel(true);
        }
    }, [visibleMarkersMap]);

    useEffect(() => {
        if (markerDetailView === markerId && mapControl === 'marker') {
            //console.log("zoom on me", markerData.marker_name);
            dispatch(setZoom(17));
            dispatch(setCenter({ lat, lng }));
        }
    }, [markerDetailView, markerId, lat, lng, dispatch, mapControl, markerData]);


    const visible = visibleMarkersMap.indexOf(markerId) !== -1;

    const [theIcon, setTheIcon] = useState(null);
    const [theLabel, setTheLabel] = useState(null);

    const createMarker = useCallback(
        () => {
            if (markerData) {
                const markerIcon = L.divIcon({
                    html: renderToString(
                        <Icon
                            path={mdiMapMarkerRadius}
                            color={markerData.marker_color}
                            size={1}
                            title={markerData.marker_name}
                        />
                    ),
                    iconSize: [40, 20],
                    iconAnchor: [20, 10],
                    className: 'dummy'
                });

                const tic = L.marker(
                    [
                        parseFloat(markerData.marker_coords.lat),
                        parseFloat(markerData.marker_coords.lng)
                    ],
                    { icon: markerIcon }
                ).on('click', () => {
                    //console.log("Marker click", markerData.marker_name, showLabel);
                    setshowLabel(!showLabel);
                });
                map.addLayer(tic);
                setTheIcon(tic);
            }
        },
        [markerData, map, showLabel],
    );

    const createLabel = useCallback(
        () => {
            if (markerData) {
                const labelIcon = L.divIcon({
                    html: renderToString(
                        <span style={{
                            backgroundColor: iconToolsColor,
                            position: 'absolute',
                            left: 0,
                            top: 0,
                        }}>
                            <b>
                                {showLabel ? `${markerData.marker_name}` : ""}
                            </b>
                        </span>
                    ),
                    iconAnchor: [-7, -23],
                    className: 'dummy'
                });
                const tlbl = L.marker(
                    [
                        parseFloat(markerData.marker_coords.lat),
                        parseFloat(markerData.marker_coords.lng)
                    ],
                    { icon: labelIcon }
                );
                map.addLayer(tlbl);
                setTheLabel(tlbl);
            }
        },
        [markerData, map, showLabel],
    );

    useEffect(() => {
        if (visible) {
            if (!theIcon) {
                //console.log("launching place marker");
                createMarker();
                createLabel();
            }
        }
        return () => {
            if (theIcon) {
                map.removeLayer(theIcon);
                setTheIcon(null);
            }
            if (theLabel) {
                map.removeLayer(theLabel);
                setTheLabel(null);
            }
        }
    }, [theIcon, theLabel, visible, map, createMarker, createLabel])


    return null;
}

export default OsmPlaceMarker;